<template>
	<v-container>
		<template>
			<div class="text-center">
				<v-dialog
				    v-model="dialog"
				    width="800"
                    @click:outside="closeModal"
                    :retain-focus="false"
                >
			        <v-card class="custom-card" rounded="0">
                        <v-toolbar
                            flat
                            color="primary"
                            class="white--text"
                        >
                            <v-toolbar-title class="font-weight-bold">{{ $t('userslist.addNewUser')}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon class="white--text" @click="closeModal">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-form
                            ref="addUser"
                            v-model="valid"
                            lazy-validation
                            autocomplete="off"
                        >
				        <v-card-text class="black--text">
                            <v-row>
                                <div class="py-0 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label for="name">{{ $t('firstName')}}<span class="red--text">*</span></label>
                                    <v-text-field
                                        v-model="user.firstName"
                                        :placeholder="$t('firstName')"
                                        outlined
                                        dense
                                        :error-messages="errors.firstName"
                                        :rules="rules.firstName"
                                    ></v-text-field>
                                </div>
                                <div class="py-0 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label for="name">{{ $t('lastName')}}<span class="red--text">*</span></label>
                                    <v-text-field
                                        v-model="user.lastName"
                                        :placeholder="$t('lastName')"
                                        outlined
                                        dense
                                        :error-messages="errors.lastName"
                                        :rules="rules.lastName"
                                    ></v-text-field>
                                </div>
                                <div class="py-0 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label for="email">{{ $t('emailId')}}<span class="red--text">*</span></label>
                                    <v-text-field
                                        v-model="user.email"
                                        :placeholder="$t('emailId')"
                                        outlined
                                        dense
                                        :error-messages="errors.email"
                                        :rules="rules.email"
                                    ></v-text-field>
                                </div>
                                <div class="py-0 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                     <label for="password">{{ $t('psw')}}<span class="red--text">*</span></label>
                                    <v-text-field
                                        type="password"
                                        v-model="user.password"
                                        :placeholder="$t('psw')"
                                        outlined
                                        dense
                                        :error-messages="errors.password"
                                        autocomplete="on"
                                        :rules="rules.password"
                                    ></v-text-field>
                                </div>
                                <!-- <div class="py-0 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label for="mobile">{{ $t('countryCode')}}<span class="red--text">*</span></label>
                                    <v-autocomplete
                                        outlined
                                        dense
                                        v-model="user.countryCode"
                                        :items="countries"
                                        item-value="MobileCode"
                                        :filter="filterCountry"
                                        :rules="rules.country"
                                        :placeholder=" $t('countryCode')"
                                    >
                                        <template v-slot:item="slotProps" >
                                            <flag class="mr-2 em" :iso="slotProps.item.Code.toLowerCase()" />
                                            
                                            {{`${slotProps.item.Name} (+${slotProps.item.MobileCode})` }}
                                        </template>
                                        <template slot="selection" slot-scope="data">
                                            <flag class="mr-2 em" :iso="data.item.Code.toLowerCase()" />
                                            
                                            {{`${data.item.Name} (+${data.item.MobileCode})` }}
                                        </template>
                                    </v-autocomplete>
                                </div> -->
                                <!-- country starts -->
                                <v-col cols="6" class="py-0">
                                    <label for="country">{{
                                        $t("country")
                                    }}</label>
                                    <v-autocomplete outlined dense v-model="user.countryId" :items="countries" item-value="name"
                                    item-text="name" :rules="rules.country" :placeholder="$t('country')"
                                    return-object @change="getState">
                                    <template v-slot:item="slotProps">
                                        <i :class="[
                                            'mr-2',
                                            'em',
                                            `em-flag-${slotProps.item.code.toLowerCase()}`,
                                        ]"></i>
                                        {{
                                            `${slotProps.item.name}`
                                        }}
                                    </template>
                                    <template slot="selection" slot-scope="data">
                                        <i :class="[
                                            'mr-2',
                                            'em',
                                            `em-flag-${data.item.code.toLowerCase()}`,
                                        ]"></i>
                                        {{ `${data.item.name}` }}
                                    </template>
                                    </v-autocomplete>
                                </v-col>
                                <!-- country ends -->

                                <!-- state starts -->
                                <v-col cols="6" class="py-0">
                                    <label for="state">{{
                                         $t(`${isKenyaClient() ? 'County' : 'provinceState'}`)
                                    }}<span class="red--text">*</span></label>
                                    <v-autocomplete outlined dense v-model="user.stateId" :items="states" :filter="filterState"
                                    :error-messages="errors.state" :rules="rules.state" :placeholder=" $t(`${isKenyaClient() ? 'County' : 'provinceState'}`)"
                                    return-object>
                                    </v-autocomplete>
                                </v-col>
                                <!-- state ends -->

                                <!-- city/town starts -->
                                <v-col cols="6" class="py-0">
                                    <label for="mobile">{{
                                        $t("cityTown")
                                    }}<span class="red--text">*</span></label>
                                    <v-text-field type="text" v-model="user.city" :placeholder="$t('cityTown')" outlined dense
                                    :error-messages="errors.city" :rules="rules.city"></v-text-field>
                                </v-col>
                                <!-- city/town ends -->
                                <div class="py-0 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label for="mobile">{{ $t('mobileNumber')}}<span class="red--text">*</span></label>
                                    <v-text-field
                                        v-model="user.mobile"
                                        :placeholder="$t('mobile')"
                                        outlined
                                        dense
                                        :error-messages="errors.mobile"
                                        :rules="rules.mobile"
                                    ></v-text-field>
                                </div>
                                
                                <div  class="py-0 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                     <label for="department">{{ $t('department')}}<span class="red--text">*</span></label>
                                    <v-select
                                        v-model="user.department"
                                        :items="departmentList"
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        dense
                                        :error-messages="errors.department"
                                        @change="getRoles"
                                        :rules="rules.department"
                                        :placeholder="$t('selectDept')"
                                    ></v-select>
                                </div>
                                <div class="py-0 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label for="role">{{ $t('role')}}<span class="red--text">*</span></label>
                                    <v-select
                                        v-model="roleIds"
                                        :items="rolesList"
                                        item-text="name"
                                        item-value="id"
                                        multiple
                                        chips
                                        outlined
                                        dense
                                        :error-messages="errors.role"
                                        :loading="roleLoading"
                                        :rules="rules.role"
                                        :placeholder="$t('selectRole')"
                                        :disabled="rolesList.length<1"
                                    ></v-select>
                                    <span class="errorf">{{ errors.role }}</span>
                                </div>
						<div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 py-0" v-if="isKenyaClient() && hasSubOrg()">
                                    <label for="societies">{{ isKenyaClient() ? $t('factories') : $t('societies') }}</label>
                                    <v-autocomplete
                                        v-model="user.societies"
                                        :items="societiesList"
                                        item-text="fullName"
                                        item-value="id"
                                        :placeholder="isKenyaClient() ? $t('selectFactories') : $t('selectSocieties')"
                                        outlined
                                        dense
                                        multiple
                                        chips
                                        deletable-chips
                                        :disabled="!isSocietyAdmin"
                                        :error-messages="errors.societies"
                                        :rules="rules.societies"
                                        :loading="societiesLoading"
                                        :search-input.sync="societiesSearch"
                                        @update:list-index="onSocietiesScroll"
                                    >
                                        <template v-slot:append-item>
                                            <v-list-item v-if="societiesLoading" class="justify-center d-flex">
                                                <v-progress-circular indeterminate size="20" color="primary"></v-progress-circular>
                                            </v-list-item>
                                            <v-list-item v-intersect="onSocietiesIntersect"></v-list-item>
                                        </template>
                                    </v-autocomplete>
                                </div>
                            </v-row>
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-checkbox
                                        v-model="generateSecretKey"
                                        :label="$t('generateSecretKey') || 'Generate Secret Key'"
                                        color="primary"
                                        @change="onGenerateSecretKeyChange"
                                    ></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row v-if="generatedSecretKey">
                                <v-col cols="12" class="py-0">
                                    <v-text-field
                                        :value="generatedSecretKey"
                                        readonly
                                        outlined
                                        dense
                                        append-icon="mdi-content-copy"
                                        @click:append="copySecretKey"
                                        :hint="$t('copySecretKeyHint')"
                                        persistent-hint
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-card-actions class="mt-10">
                                <v-spacer></v-spacer>
                                <v-btn @click="closeModal" outlined right height="44" width="116" depressed color="primary">
                                    {{ $t('cancel')}}
                                </v-btn>
                                <v-btn @click="saveUser" right height="44" width="116" color="primary">
                                    {{ $t('submit')}}
                                </v-btn>
                        </v-card-actions>
				        </v-card-text>
                        </v-form>
			        </v-card>
		        </v-dialog>
	        </div>
        </template>
    </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin"
import generalMixin from "@/mixins/GeneralMixin";
import PermissionsMixin from "@/mixins/PermissionsMixin"
import { kenyaCounties } from "@/constants/countries.js"
import { isKenyaClient } from "@/utils";
import UserService from "@/_services/UserService"
import { getCountries, getStates } from 'country-state-picker'

	export default {
        created() {
            const fetchData = async () => {
                this.startLoading()
                this.departmentList = await this.getDepartments()
                await this.getRoles()
                await this.getSocieties()
                this.stopLoading()
            }
            fetchData()
            this.getCountry();
        },
        computed: {
            dialog() {
                return this.dialogI;
            },
            isSocietyAdmin() {
                if (!this.roleIds || this.roleIds.length === 0 || !this.rolesList || this.rolesList.length === 0) {
                    return false;
                }
                // Check if any selected role matches society admin roles
                const selectedRoles = this.rolesList.filter(role => this.roleIds.includes(role.id));
                return selectedRoles.some(role => {
                    // Check both role name and role id (in case id is the role name string)
                    const roleName = String(role.name || '').toLowerCase();
                    const roleId = String(role.id || '').toLowerCase();
                    return roleName === 'naccu_society_admin' || roleName === 'ptsi_society_admin' || roleName === 'union_admin' ||
                           roleId === 'naccu_society_admin' || roleId === 'ptsi_society_admin' || roleId === 'union_admin';
                });
            }
        },
        watch: {
            societiesSearch() {
                // Debounce search to avoid too many API calls
                if (this.searchTimeout) {
                    clearTimeout(this.searchTimeout);
                }
                this.searchTimeout = setTimeout(() => {
                    this.societiesPage = 1;
                    this.societiesHasMore = true;
                    this.getSocieties(1, false);
                }, 300);
            }
        },
        data() {
            return {
                countries: [],
                states: [],
                roleIds:[],
                valid: true,
                departmentList: [],
                rolesList: [],
                roleLoading: false,
                fieldType: { text: 'text'},
                error: false,
                errors: { firstName: '', lastName: '', email: '', mobile: '', password: '', department: '', role: '', societies: ''},
                user: {
                    firstName : '',
                    lastName : '',
                    email: '',
                    mobile: '',
                    password: '',
                    department: 'admin',
                    role: 'indonesia_admin',
                    countryCode: '',
                    societies: []
                },
                rules: {
                    firstName: [
                        v => !!v || this.$t('addEdituser.firstNameRequired'),
                        v => /^[a-z0-9\s]+$/i.test(v) || this.$t('addEdituser.firstNameOllyAlpha'),
                        v => (v && v.length <= 15) || this.$t('addEdituser.firstNameLimit'),
                    ],
                    lastName: [
                        v => !!v || this.$t('addEdituser.lastNameRequired'),
                        (v) => /^[a-z0-9\s]+$/i.test(v) || this.$t('addEdituser.lastNameOllyAlpha'),
                        v => (v && v.length <= 15) || this.$t('addEdituser.lastNameLimit'),
                    ],
                    email: [
                        v => !!v || this.$t('addEdituser.emailReuired'),
                        v => /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/.test(v) || this.$t('addEdituser.emailInvalid'),
                    ],
                    mobile: [
                        v => !!v || this.$t('addEdituser.mobileRequired'),
                        v => this.validMobileNumber(v) || this.$t('addEdituser.invalidMobile'),
                    ],
                    password: [
                        v => !!v || this.$t('addEdituser.pswRequired'),
                    ],
                    department: [
                        v => !!v || this.$t('addEdituser.deptRequired'),
                    ],
                    role: [
                        v => !!v || this.$t('addEdituser.roleRequired'),
                    ],
                    country: [(v) => !!v || this.$t("addEdituser.countryRequired")],
                    state: [(v) => !!v || this.$t(`${isKenyaClient() ? 'County is required' : 'stateIsReq'}`)],
                     
                    city: [(v) => !!v || this.$t("cityIsReq")],
                    societies: [
                        // optional: add validation if needed
                    ],
                },
                select: null,
                societiesList: [],
                societiesLoading: false,
                societiesSearch: '',
                societiesPage: 1,
                societiesHasMore: true,
                searchTimeout: null,
                generateSecretKey: false,
                generatedSecretKey: '',
            }
        },
        methods: {
            isKenyaClient() {
                return isKenyaClient();
            },
            onFilter(item, queryText){
                    return item.Name.toLocaleLowerCase().includes(queryText.toLocaleLowerCase())
                        ||  item.MobileCode.toLocaleLowerCase().includes(queryText.toLocaleLowerCase())

            },
			closeModal() {
                this.generateSecretKey = false;
                this.generatedSecretKey = '';
                this.$emit('closeAddUser')
            },
			hasSubOrg() {
				try {
					const u = JSON.parse(localStorage.getItem('user'))
					return !!(u && (u.subOrgId || u.subOrganizationId))
				} catch (e) {
					return false
				}
			},
            saveUser() {
                // this.emptyErrors();
                // if(!this.onlyAlpha(this.user.name)){
                //     this.errors.name = 'Name can contain only alphbets';
                //     this.error = true;
                // }
                // if(!this.validateEmail(this.user.email)){
				//     this.errors.email = 'Invalid email format.';
                //     this.error = true;
			    // }
                // if(!this.validMobileNumber(this.user.mobile)) {
                //     this.errors.mobile = 'Invalid mobile number format.';
                //     this.error = true;
                // }
                // if(this.user.password.trim() == ''){
                //     this.errors.password = 'Password can not be empty'
                //     this.error = true;
                // }
                // if(this.error)
                //     return;
                if(!this.$refs.addUser.validate()) return;
                this.startLoading()

				this.user.country = typeof this.user.countryId == "object"? this.user.countryId.name : this.user.countryId;
                this.user.state = this.user.stateId;
                this.user.roleIds = this.roleIds;
                this.user.countryCode = typeof this.user.countryId == "object"? this.user.countryId.dial_code : this.user.dial_code;
                delete this.user.countryId;    
				if (!this.hasSubOrg() || !this.isSocietyAdmin) {
					this.user.societies = []
				}
                
                // Generate secret key if checkbox is checked
                if (this.generateSecretKey) {
                    // Use the already generated key if available, otherwise generate new one
                    if (!this.generatedSecretKey) {
                        this.generatedSecretKey = this.generateSecretKeyValue();
                    }
                    this.user.secretKey = this.generatedSecretKey;
                }
                
                UserService.addUser(this.user)
                .then( data => {
                    if(data.success){
                        this.$emit('userAdded', { success:true, message: data.message});
                    }else{
                        this.$emit('userAdded', { success:false, message: data.message});
                    }
                    this.closeModal();
                    this.stopLoading()
                })
                .catch( err => {
                    if(err.response.data.message.errors.length > 0){
                        err.response.data.message.errors.forEach(e => {
                            this.errors[e.param] = e.msg;
                        });
                    }
                    this.stopLoading()
                });
            },

            emptyErrors() {
                this.error = false;
                this.errors.firstName = '';
                this.errors.lastName = '';
                this.errors.email = '';
                this.errors.mobile = '';
                this.errors.password = '';
                this.errors.department = '';
                this.errors.role = '';
            },
            async getRoles() {
                this.rolesList = []
                this.roleLoading = true
                this.rolesList = await this.getRolesList()
                this.roleLoading = false
            },
            getCountry() {
                this.countries = getCountries()
            },
        getState(val) {
                if(val.code == "ke") {
                    this.states = kenyaCounties;
                   return;
                }
                this.states = getStates(val.code)
                this.country = val
            },
            onSocietiesScroll(index) {
                if (index >= this.societiesList.length - 5 && this.societiesHasMore && !this.societiesLoading) {
                    this.getSocieties(this.societiesPage + 1, true);
                }
            },
            onSocietiesIntersect(entries, observer, isIntersecting) {
                const intersecting = Array.isArray(entries) ? entries.some(e => e.isIntersecting) : isIntersecting;
                if (intersecting && this.societiesHasMore && !this.societiesLoading) {
                    this.getSocieties(this.societiesPage + 1, true);
                }
            },
            async getSocieties(page = 1, append = false, limit = 100) {
                if (this.societiesLoading) return;
                this.societiesLoading = true;
                try {
                    const searchPhrase = this.societiesSearch || '';
                    // For create mode, don't pass userId - this will exclude all linked buying stations
                    const response = await this.$http.get(`/available-buying-stations?page=${page}&limit=${limit}&search=${searchPhrase}`);
                    if (response.data && response.data.success) {
                        const newSocieties = response.data.data.rows || [];
                        this.societiesList = append ? [...this.societiesList, ...newSocieties] : newSocieties;
                        this.societiesHasMore = newSocieties.length === limit;
                        this.societiesPage = page;
                    }
                } catch (e) {
                    if (!append) this.societiesList = [];
                } finally {
                    this.societiesLoading = false;
                }
            },
            generateSecretKeyValue() {
                // Generate a 256-bit (32-byte) secret key encoded as hex (64 characters)
                const bytes = new Uint8Array(32); // 32 bytes = 256 bits
                
                // Use crypto.getRandomValues for cryptographically secure random bytes
                if (window.crypto && window.crypto.getRandomValues) {
                    window.crypto.getRandomValues(bytes);
                } else {
                    // Fallback to Math.random (less secure, but better than nothing)
                    for (let i = 0; i < 32; i++) {
                        bytes[i] = Math.floor(Math.random() * 256);
                    }
                }
                
                // Convert bytes to hex string (64 hex characters)
                let secretKey = '';
                for (let i = 0; i < bytes.length; i++) {
                    const hex = bytes[i].toString(16).padStart(2, '0');
                    secretKey += hex;
                }
                
                return secretKey;
            },
            onGenerateSecretKeyChange() {
                if (this.generateSecretKey) {
                    // Generate the secret key when checkbox is checked
                    this.generatedSecretKey = this.generateSecretKeyValue();
                } else {
                    // Clear the secret key when checkbox is unchecked
                    this.generatedSecretKey = '';
                }
            },
            copySecretKey() {
                if (this.generatedSecretKey) {
                    navigator.clipboard.writeText(this.generatedSecretKey).then(() => {
                        this.$notify({
                            title: this.$t('copied') || 'Copied',
                            text: this.$t('secretKeyCopied') || 'Secret key copied to clipboard',
                            type: 'success'
                        });
                    }).catch(() => {
                        // Fallback for older browsers
                        const textArea = document.createElement('textarea');
                        textArea.value = this.generatedSecretKey;
                        document.body.appendChild(textArea);
                        textArea.select();
                        document.execCommand('copy');
                        document.body.removeChild(textArea);
                        this.$notify({
                            title: this.$t('copied') || 'Copied',
                            text: this.$t('secretKeyCopied') || 'Secret key copied to clipboard',
                            type: 'success'
                        });
                    });
                }
            },
        },
        props: {
            'dialogI': {
                type: Boolean,
                required: true
            }, 
        },
        mixins: [loadingMixin, generalMixin, PermissionsMixin]
    };
</script>

<style>
.v-dialog::-webkit-scrollbar {
  width: 0px;
}
.v-dialog::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.v-dialog::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.custom-card {
	background: #FFFFFF !important;
	box-shadow: 0px 30px 30px rgb(106 119 132 / 41%) !important;
	border-radius: 23px !important;
}
.custom-card .v-card__text {
	width: 100%;
	padding: 37px 60px !important;
}
.card-heading-1 {
	margin-bottom: 28px;
}
.custom-card .v-card__text .card-heading-1 h2 {
	font-size: 30px;
	font-weight: 700;
}

.form label {
	display: inline-block;
	max-width: 100%;
	margin-bottom: 5px;
	font-size: 15px;
	font-family: Poppins-Medium;
}
</style>
